module.exports = __webpack_public_path__ + "static/media/louvre-exposition-petite-galerie-140-87-px.1a9cc643.jpg";